export default {
  install: function(Vue, options) {
    Vue.filter('formatarNumero', function(valor, removerFormato = false, retornarZero = true, casasDecimais = 2) {
      if (removerFormato) {
        if (!valor) return valor;
        
        if (typeof valor === 'number') return valor;

        let numero = valor.replace(/\./g, '').replace(/,/g, '.');

        return parseFloat(isNaN(numero) ? 0.00 : (+numero).toFixed(casasDecimais));
      } else {
        const formato = new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: casasDecimais,
          maximumFractionDigits: casasDecimais
        });
        
        if (isNaN(valor) && retornarZero) {
          return formato.format(0);
        } else if ((isNaN(valor) || valor === '' || valor === null) && !retornarZero) {
          return '';
        }
        
        return formato.format(valor);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./FrontEnd/filtros/formatar-numero.js